import * as React from 'react';
import Slider, { SliderProps, SliderThumb } from '@mui/material/Slider';
import { alpha, styled } from '@mui/material/styles';

import { ReactComponent as ThumbIcon } from 'assets/images/slider-thumb.svg';

function CustomThumbComponent(props: React.HTMLAttributes<unknown>) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <ThumbIcon />
    </SliderThumb>
  );
}

const StyledComponent = styled(Slider)<SliderProps>(() => ({
  color: '#35C7FF',
  height: '1px',
  '& .MuiSlider-thumb': {
    color: '#35C7FF',
    '&:hover, &.Mui-focusVisible': {
      color: '#35C7FF',
      boxShadow: `0px 0px 0px 8px ${alpha('#35C7FF', 0.16)}`,
    },
    '&.Mui-active': {
      color: '#35C7FF',
      boxShadow: `0px 0px 0px 14px ${alpha('#35C7FF', 0.16)}`,
    },
  },
  '& .MuiSlider-track': {
    color: '#D0D3D6',
    height: '1px',
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: '#D0D3D6',
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#35C7FF',
    height: 8,
    width: 1,
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: '#35C7FF',
    },
  },
}));

export default function StyledSliderV2({ ...props }: SliderProps) {
  return <StyledComponent {...props} slots={{ thumb: CustomThumbComponent }} />;
}
